import React from "react";

import classes from './style.module.scss'

const Subtitle = ({ children }) => {
    return <p className={classes.subtitle}>{children}</p>;
};

export default Subtitle;
